import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { Toaster } from 'sonner';
import { queryClient } from './lib/query';
import { router } from './routes';
import './styles.css';

// Apply the stored theme before first paint so there is no flash of the wrong palette.
try {
  const stored = localStorage.getItem('atlas-theme');
  if (stored === 'light' || stored === 'dark') document.documentElement.setAttribute('data-theme', stored);
} catch {
  // storage unavailable — fall back to the system preference
}

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" closeButton richColors />
    </QueryClientProvider>
  </StrictMode>,
);
